export default {
  title: 'User Profile',
  close: 'Close',
  rules: {
    required: 'Field is required',
    min: 'Field must have at least',
    max: 'Field must be not longer than',
    characters: 'characters',
    fieldIncorrect: 'Field is incorrect',
    loginIncorrect: 'E-mail is incorrect',
    passwordIncorrect: 'Password is incorrect',
    passwordMustDiffer: 'New password must be different from the old password',
    passwordMustBeSame: 'Old and new password can\'t be different',
  },
  user: {
    login: 'E-mail address',
    name: 'User name',
    restore: 'Restore',
    save: 'Save',
    updated: 'User data has been updated',
  },
  password: {
    old: 'Old password',
    new: 'New password',
    repeat: 'Repeat password',
    updated: 'Password has been updated',
    updateError: 'Password update error',
    clear: 'Clear',
    change: 'Change passowrd',
  },
}
